"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setGlobalStorage = void 0;
const command_manager_1 = require("../../command_manager");
const i18n_1 = require("../../exports/i18n");
const model_1 = require("../../model");
const store_1 = require("../../exports/store");
const types_1 = require("../../types");
const MAX_GLOBAL_STORAGE_KEY = 100;
exports.setGlobalStorage = {
    undoable: false,
    execute(context, options) {
        const state = context.model;
        const { resourceId, key, value } = options;
        const widgetPack = store_1.Selectors.getResourcePack(state, resourceId, types_1.ResourceType.Widget);
        if (!widgetPack) {
            return null;
        }
        const widgetSnapshot = widgetPack.widget.snapshot;
        if (Object.keys(widgetSnapshot).length > MAX_GLOBAL_STORAGE_KEY) {
            throw new Error((0, i18n_1.t)(i18n_1.Strings.global_storage_size_large));
        }
        const setGlobalStorageAction = model_1.WidgetActions.setGlobalStorage2Action(widgetSnapshot, { key, value });
        if (!setGlobalStorageAction) {
            return null;
        }
        return {
            resourceId: options.resourceId,
            resourceType: options.resourceType,
            result: command_manager_1.ExecuteResult.Success,
            actions: setGlobalStorageAction,
        };
    },
};
//# sourceMappingURL=set_global_storage.js.map